import { ExportToCsv } from 'export-to-csv'

// var data = [
//   {
//     name: 'Test 1',
//     age: 13,
//     average: 8.2,
//     approved: true,
//     description: "using 'Content here, content here' "
//   },
//   {
//     name: 'Test 2',
//     age: 11,
//     average: 8.2,
//     approved: true,
//     description: "using 'Content here, content here' "
//   },
//   {
//     name: 'Test 4',
//     age: 10,
//     average: 8.2,
//     approved: true,
//     description: "using 'Content here, content here' "
//   },
// ]

const defaUltOptions = {
  // filename: 'genereted',
  fieldSeparator: ',',
  quoteStrings: '"',
  decimalSeparator: '.',
  showLabels: true,
  showTitle: false,
  title: '',
  useTextFile: false,
  useBom: true,
  useKeysAsHeaders: true,
  // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
}

const useExportToCSV = () => {
  const exportCSV = (data, options = {}) => {
    // console.table(options)
    const csvExporter = new ExportToCsv({ ...defaUltOptions, ...options })
    csvExporter.generateCsv(data)
  }

  return {
    exportCSV
  }
}

export default useExportToCSV
